import './retrait-fonds-form.css'
import { Form } from 'semantic-ui-react'
import './retrait-fonds-form.css'
import React, { useState } from 'react'
import CompteBeneficiaires from '../../../model/entities/compte-beneficiaires'
import { InputField } from '../../generic/input-field'
import { SubmitButton } from '../../generic/submit-button'
import { DefaultResponse } from '../../../model/dto/response'
import { SimpleButton } from '../../generic/simple-button'
import { AuthenticationState } from '../../../model/state/authentication-state'
import { useSelector } from 'react-redux'
import { ApplicationState } from '../../../store'
import { PayoutCitoyenbody } from '../../../model/dto/body/payout-citoyen-body'
import { investmentService } from '../../../services/investment-service'
import { FormErrorHeader } from '../../generic/form-error-header'

type Props = {
    selectedAccount: CompteBeneficiaires,
    walletValue: number,
    onSubmitSuccess: (response: DefaultResponse)=> void; 
    onCancelAction: ()=> void;
}

type FieldData = {
    value?: any,
    name: string,
    isValid?: boolean,
    key?: string
};

type FormData = {
    montantRetrait: FieldData
}

export default function RetraitFondsForm({selectedAccount, walletValue, onSubmitSuccess, onCancelAction}: Props) {
    const loginProps: AuthenticationState = useSelector<ApplicationState, AuthenticationState>(state => state.authentication)
    const [form, setForm] = useState<FormData>({
        montantRetrait: {value: '', name: 'montantRetrait', isValid: true}
    }) 
    const [isFormError, setIsFormError] = useState(false)
    const [formSubmitted, setFormSubmitted] = useState(false)
    const [errorBackPayoutMessage, setErrorBackPayoutMessage] = useState<string | undefined>()

    const handleMontantChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName?: string, isValid?: boolean, key?: string): void => {
        const fieldValue: string = e.target.value;
        const parsedValue = fieldValue.replace(',', '.')
        setIsFormError(false)
        setForm({...form, [fieldName!]: {value: parsedValue, name: fieldName, isValid: isValid, key: key}})
    }

    const validateMontant = (value : any) => {
        if (value > 0) {
            const regex = /^\d+((\.|,)\d+)?/g;
            const valueMontant = parseFloat(value.replace(',', '.'));
            return ( regex.test(value) && valueMontant <= walletValue)
        } else {
            return false
        }
    }
    
    const isFormValid = (): boolean => {
        // Si l'utilisateur est bloqué, on ne valide jamais le formulaire
        if(loginProps.user?.IsBloque ?? false) {
            return false
        }
        return validateMontant(form.montantRetrait.value)
    }

    const onFormNotValid = (): void => {
    if(loginProps.user?.IsBloque ?? false) {
        return
    }

    setIsFormError(true)
}

    const emptyMontantMessage = "Merci de renseigner un montant non nul"
    const tooHightMontantMessage = "Merci de renseigner le montant de votre retrait inférieur ou égal à votre solde"
    const errorMessage = form.montantRetrait.value === '0' || !form.montantRetrait.value ? emptyMontantMessage : tooHightMontantMessage

    const body: PayoutCitoyenbody = {
        MontantRetrait: Math.round(parseFloat(form.montantRetrait.value) * 100),
        CompteBeneficiaireId: selectedAccount.Id
    }
    
  return (
    <Form>
        <FormErrorHeader
            message={errorBackPayoutMessage ?? ''}
            displayed={errorBackPayoutMessage !== undefined}
        />
        <FormErrorHeader 
            message="Veuillez corriger le champs en erreur"
            displayed={isFormError}
        />
        <InputField 
            data={form.montantRetrait}
            label="Montant du retrait (en euros)"
            onChange={handleMontantChange}
            validateField = {validateMontant}
            error={errorMessage}
            submitted={formSubmitted}
        />
        <div className='retrait-form-container-buttons'>
            <SubmitButton 
                label='Valider'
                action={() => investmentService.askForPayoutCitoyen(body, loginProps?.oauth)}
                onActionFailure={(response:DefaultResponse)=> setErrorBackPayoutMessage(response.Error)}
                validateForm={isFormValid}
                onFormNotValid={onFormNotValid}
                onActionSuccess={onSubmitSuccess}
            />
            <SimpleButton 
                label='Annuler'
                onClick={onCancelAction}
            />
        </div>
    </Form>
  )
}
